<template>
  <b-container class="p-4">
    <b-row>
      <b-col><h4>List of configured client ecosystem integrations</h4></b-col>
    </b-row>


    <b-row class="mt-3">
      <b-col cols="12">
        <b-tabs content-class="mt-3">
          <b-tab title="Saml" active>
            <saml-tab />
          </b-tab>
          <b-tab title="Other">
            <other-tab />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import OtherTab from './OtherTab.vue';
import SamlTab from './SamlTab.vue';

export default {
  name: 'SSOIntegrations',
  components: {
    OtherTab,
    SamlTab,
  },
};
</script>
